import { render, staticRenderFns } from "./BrowserCompatibilityDialog.vue?vue&type=template&id=6aab0b00&scoped=true"
import script from "./BrowserCompatibilityDialog.vue?vue&type=script&lang=js"
export * from "./BrowserCompatibilityDialog.vue?vue&type=script&lang=js"
import style0 from "./BrowserCompatibilityDialog.vue?vue&type=style&index=0&id=6aab0b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab0b00",
  null
  
)

export default component.exports